import { useState, useRef } from "react";

/**
 * useKeyboardHandlers
 *
 * Extracts keyboard-related state and handlers from PointOfsaleCore:
 * - keyboardType state
 * - handleKeyPress
 * - handleKeyboardInput
 * - keyboard refs
 */
const useKeyboardHandlers = ({
  searchParkedBill,
  searchOrderHistory,
  setProductSearchInput,
  clearProductSearchResults,
  setParkedBillSearchInput,
  setOrderHistoryInput,
}) => {
  const [keyboardType, setKeyboardType] = useState({
    product: false,
    parkedBill: false,
    salesHistoryDoc: false,
    salesHistoryCus: false,
    searchCus: false,
    productSearch: false,
    giftCardSearch: false,
    addCustomer: false,
  });
  const [layout, setLayout] = useState("default");
  const [inputName, setInputName] = useState("");

  const keyboardProduct = useRef(null);
  const keyboardParkbill = useRef(null);
  const orderHistorySearchInputRef = useRef(null);

  const handleKeyPress = (button) => {
    if (button === "{shift}" || button === "{caps}") setLayout("shift");
    if (button === "{default}" || button === "{small}") setLayout("default");
    if (button === "{numbers}") setLayout("numbers");
    if (button === "{number}") setLayout("number");
    if (button === "{done}") {
      switch (true) {
        case keyboardType.parkedBill:
          searchParkedBill();
          break;
        case keyboardType.salesHistoryDoc:
          searchOrderHistory();
        case keyboardType.salesHistoryCus:
          searchOrderHistory();
          break;
        case keyboardType.product:
          break;
        default:
          break;
      }
    }
  };

  const handleKeyboardInput = (inputs) => {
    if (keyboardType.parkedBill === true) {
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setParkedBillSearchInput(inputs.default);
    } else if (keyboardType.product === true) {
      if (inputs.default === "") {
        clearProductSearchResults();
      } else {
        setProductSearchInput(inputs.default);
      }
    } else if (keyboardType.salesHistoryDoc === true) {
      setOrderHistoryInput(inputs.default);
    } else if (keyboardType.salesHistoryCus === true) {
      setOrderHistoryInput(inputs.default);
    }
  };

  return {
    keyboardType, setKeyboardType,
    layout, setLayout,
    inputName, setInputName,
    keyboardProduct,
    keyboardParkbill,
    orderHistorySearchInputRef,
    handleKeyPress,
    handleKeyboardInput,
  };
};

export default useKeyboardHandlers;
